import Matchmaking, { STATES } from "../../model/matchmaking";

export function setMatchmakingState(setState: React.Dispatch<React.SetStateAction<Matchmaking>>, matchmakingState: STATES): void {
    setState((matchmaking) => ({ ...matchmaking, state: matchmakingState }));
}

export function setMatchmakingOponnentId(setState: React.Dispatch<React.SetStateAction<Matchmaking>>, opponentId: string): void {
    setState((state) => ({ ...state, opponentId: opponentId }));
}

export function setMatchmakingChannelId(setState: React.Dispatch<React.SetStateAction<Matchmaking>>, channelId: string): void {
    setState((state) => ({ ...state, channelId: channelId }));
}
